import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DeudaResponse } from 'src/app/core/dtos/deudaResponse';
import { environment } from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {
 
  private apiUrl = `${environment.apiUrl}/Cliente/`;
  constructor(private http: HttpClient) {}

  obtenerClientePorId(usuarioId: number,clienteId:number): Observable<any> {
    return this.http.get(`${this.apiUrl}getClienteById?usuarioId=${usuarioId}&clientId=${clienteId}`);
  }
  obtenerClientesPorUsuario(usuarioId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}getAll?usuarioId=${usuarioId}`);
  }
  guardarCliente(usuarioId: number,cliente: any): Observable<any> {
    return this.http.post(`${this.apiUrl}create?usuarioId=${usuarioId}`, cliente);
  }

  buscarClientes(usuarioId:number,termino: string): Observable<any> {
    return this.http.get(`${this.apiUrl}getByIdOrName?usuarioId=${usuarioId}&criterio=${termino}`);
  }

  updateCliente(id: number, cliente: any): Observable<any> {
  return this.http.put(`${this.apiUrl}edit?clienteId=${id}`, cliente);
  }

  deleteCliente(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}delete?id=${id}`);
  }


  obtenerDeudaPorCliente(clienteId: number): Observable<DeudaResponse[]> {
    return this.http.get<DeudaResponse[]>(`${this.apiUrl}obtener-productos-cliente?clienteId=${clienteId}`);
  }

  updateDeudaTotal(clienteId: number, deudaTotal: number): Observable<any> {
    return this.http.put(`${this.apiUrl}update-deuda-total?clienteId=${clienteId}&deudaTotal=${deudaTotal}`, { });
  }
  
  guardarProductosNuevos(clienteId:number,productos:any): Observable<any> {
    return this.http.post(`${this.apiUrl}agregar-productos?clienteId=${clienteId}`, productos);
  }
  
  actualizarProductosExistentes(clienteId: number, productos: any[]): Observable<any> {
    return this.http.put(`${this.apiUrl}actualizar-productos-existentes?clienteId=${clienteId}`, productos);
  }
  eliminarProducto(productoId: number) {
    return this.http.put(`${this.apiUrl}eliminar-producto?productoId=${productoId}`,{});
  }
}
